// External component imports
import { Typography } from '@interstate/components/Typography';
import { useInterstateTheme } from '@interstate/components/InterstateThemeProvider';
import { Alert } from '@interstate/components/Alert';

// Constants and types
import { COMPLIANCE_OFAC_MESSAGE, COMPLIANCE } from '../../shared/constants';
import { ComplianceStatus } from '../../shared/types';

// Local style imports
import { ContainerBox } from '../ComplianceAccordian.style';
import { Separator } from '../../ComplianceForm.style';
import { useSelector } from 'react-redux';
import * as complianceSelectors from '@makemydeal/dr-dash-store/selectors/complianceSelectors';
import type { ComplianceSections } from '../../shared/types';

export const OFACDetails = () => {
    const theme = useInterstateTheme();
    const participantMatch = useSelector(complianceSelectors.getComplianceParticipantForShopper);

    const data = (participantMatch?.compliance ?? {}) as Partial<ComplianceSections>;
    const OFACData = data.OFAC ?? {};

    const status = OFACData.status ?? '';

    const message = COMPLIANCE_OFAC_MESSAGE.MESSAGES[status as keyof typeof COMPLIANCE_OFAC_MESSAGE.MESSAGES] || '';

    // Handle ERROR status - display standard error message
    if (status === ComplianceStatus.ERROR) {
        return (
            <>
                <Alert data-testid="ofac-error-alert" title={COMPLIANCE.ERROR_ALERT.TITLE} type="error">
                    <span>{COMPLIANCE.ERROR_ALERT.DESCRIPTION}</span>
                </Alert>
                <Separator
                    isVisible={true}
                    theme={theme}
                    className="ofac_error_separator"
                    data-testid="ofac_error_separator"
                    aria-hidden="true"
                />
            </>
        );
    }

    // Default case for PASS, FAIL, STARTED, NOT_STARTED, NOT_APPLICABLE, COMPLETED
    return (
        <ContainerBox>
            {message.title && <Typography variant="strong-sm">{message.title}</Typography>}
            {message.description && <Typography variant="body-sm">{message.description}</Typography>}
        </ContainerBox>
    );
};
